import { manageConstants, userinfoConstants } from '../../constants'

const initialState = {
  data: {},
  status: [],
  isLoading: false,
  isUpdate: false,
  isFailure: false,
  isSend: false,
  isSearch: false,
  inviteList: {},
  managerInfo: null,
  delegateList: null,
  isDelegate: false,
  isCancel: false,
  errorMessage: '',
}

export default function manage(state = initialState, action) {
  switch (action.type) {
    /** 이용자 초대목록 조회 **/
    case manageConstants.LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case manageConstants.LOAD_SUCCESS:
      return {
        ...state,
        inviteList: action.response.data?.payload,
        isLoading: false,
        isUpdate: false,
        isDrop: false,
      }
    case manageConstants.LOAD_FAILURE:
      return {
        isLoading: false,
        isFailure: true,
      }

    /** 이용자 선택 **/
    case manageConstants.CHECK_INVITE_REQUEST:
      return {
        ...state,
        checkInfo: action.response,
      }

    /** 이용자 대기자 선택 **/
    case manageConstants.WAIT_INVITE_REQUEST:
      return {
        ...state,
        isWait: action.response ? action.response : false,
      }

    /** 이용자 정보 수정 **/
    case manageConstants.UPDATE_INVITE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case manageConstants.UPDATE_INVITE_SUCCESS:
      console.log(action)
      console.log(state)
      return {
        ...state,
        isUpdate: true,
        isLoading: false,
        // methodType:
      }
    case manageConstants.UPDATE_INVITE_FAILURE:
      return {
        isLoading: false,
        isFailure: true,
        errorMessage: action.response.response.data.errors.message,
      }

    /** 이용자 탈퇴 **/
    case manageConstants.UPDATE_DROP_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case manageConstants.UPDATE_DROP_SUCCESS:
      return {
        ...state,
        isDrop: true,
        isLoading: false,
      }
    case manageConstants.UPDATE_DROP_FAILURE:
      return {
        isLoading: false,
        isFailure: true,
      }

    /** 대기자 선택 **/
    case manageConstants.CHECK_WAIT_REQUEST:
      return {
        ...state,
        rData: action.data,
      }

    /** 초대이메일전송 **/
    case manageConstants.SEND_INVITE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case manageConstants.SEND_INVITE_SUCCESS:
      return {
        ...state,
        isSend: true,
        isLoading: false,
      }
    case manageConstants.SEND_INVITE_FAILURE:
      return {
        isLoading: false,
        errorMessage: action.response.response.data.errors.message,
      }

    /** 사업자 정보 조회 **/
    case manageConstants.LOAD_GROUP_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case manageConstants.LOAD_GROUP_SUCCESS:
      return {
        ...state,
        data: action.response.data?.payload,
        isSearch: true,
        isUpdate: false,
      }
    case manageConstants.LOAD_GROUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    case manageConstants.RESET_DELEGATE:
      return {
        ...state,
        isLoading: true,
        isFailure: false,
        isDelegate: false,
        isCancel: false,
      }

    /** 권한 위임 대기중인 이용자 정보 조회 **/
    case manageConstants.GET_PERMISSION_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFailure: false,
      }
    case manageConstants.GET_PERMISSION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        managerInfo: action.response.data?.payload,
      }
    case manageConstants.GET_PERMISSION_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /** 위임 가능한 사용자 목록 조회 **/
    case manageConstants.GET_DELEGATE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFailure: false,
      }
    case manageConstants.GET_DELEGATE_LIST_SUCCESS:
      return {
        ...state,
        delegateList: action.response.data?.payload,
        isLoading: false,
      }
    case manageConstants.GET_DELEGATE_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    /** 권한 위임 신청 **/
    case manageConstants.DELEGATE_PERMISSION_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFailure: false,
      }
    case manageConstants.DELEGATE_PERMISSION_SUCCESS:
      return {
        ...state,
        isDelegate: true,
        isLoading: false,
      }
    case manageConstants.DELEGATE_PERMISSION_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /** 위임 신청 취소 **/
    case manageConstants.CANCEL_DELEGATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFailure: false,
      }
    case manageConstants.CANCEL_DELEGATE_SUCCESS:
      return {
        ...state,
        isCancel: true,
        isLoading: false,
      }
    case manageConstants.CANCEL_DELEGATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /** 주소 갱신 **/
    case manageConstants.CHANGE_ADDRESS:
      return {
        ...state,
        address: action.addressObj,
      }
    /*********
         담당자 정보변경
         **********/
    case manageConstants.UPDATE_GROUP_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case manageConstants.UPDATE_GROUP_SUCCESS:
      return {
        ...state,
        data: action.response.data?.payload,
        isUpdate: true,
      }
    case manageConstants.UPDATE_GROUP_FAILURE:
      return {
        isLoading: false,
        isUpdate: false,
      }

    default:
      return state
  }
}
